import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { GATEWAYS, DEFAULT_GATEWAY, LOCAL_STORAGE_KEY_PREFERRED_GATEWAY } from "../../Constants";
import { SlideOutMenuPanel } from "../SlideOutMenuPanel/SlideOutMenuPanel";
import styles from "./GatewayMenu.module.scss";

const GatewayMenu = ({ labels, showGateway, onGatewayChange, focusOnShouldIgnore }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [currentGateway, setCurrentGateway] = useState(DEFAULT_GATEWAY);

	const handleChangeGateway = gateway => {
		localStorage.setItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY, JSON.stringify(gateway));
		setCurrentGateway(gateway);

		setIsOpen(false);

		if (typeof onGatewayChange === "function") {
			onGatewayChange(gateway);
		}
	};

	useEffect(() => {
		let defaultGateway = DEFAULT_GATEWAY;

		try {
			const storedGateway = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY));
			if (storedGateway) {
				const foundGateway = GATEWAYS?.find(group =>
					group?.gateways?.some(gateway => gateway?.value === storedGateway?.value)
				);

				if (foundGateway) {
					defaultGateway = storedGateway;
				}
			}
		} catch (err) {
			console.error(err);
		}

		setCurrentGateway(defaultGateway);
	}, []);

	return (
		<>
			{showGateway && (
				<>
					<div className={styles.gatewaySwitcher}>
						{currentGateway?.label}
						<button
							type="button"
							className={styles.gatewaySwitcherButton}
							onClick={() => setIsOpen(true)}
							aria-label={labels.openGatewayMenu}
							aria-expanded={isOpen}
							aria-controls="main-menu-gateway-nav">
							{labels.changeGateway}
						</button>
					</div>
					<SlideOutMenuPanel
						id="main-menu-gateway-nav"
						labels={{
							title: labels.gatewayHeader,
							closeMenu: labels.closeGatewayMenu,
						}}
						isOpen={isOpen}
						handleClose={() => setIsOpen(false)}
						focusOnShouldIgnore={focusOnShouldIgnore}>
						<ul className={styles.container} id="main-menu-gateway-nav">
							{GATEWAYS?.map(gateways => (
								<li className={styles.province} key={gateways?.label}>
									<span className={styles.provinceLabel}>{gateways?.label}</span>
									<ul className={styles.gatewayCityContainer}>
										{gateways?.gateways?.map(gateway => (
											<li key={gateway?.value}>
												{currentGateway?.value === gateway?.value ? (
													<span className={styles.currentGateway}>{gateway?.label}</span>
												) : (
													<button
														type="button"
														className={styles.gatewayCity}
														onClick={() => handleChangeGateway(gateway)}
														value={gateway?.value}>
														{gateway?.label}
													</button>
												)}
											</li>
										))}
									</ul>
								</li>
							))}
						</ul>
					</SlideOutMenuPanel>
				</>
			)}
		</>
	);
};

GatewayMenu.propTypes = {
	labels: PropTypes.shape({
		openGatewayMenu: PropTypes.string,
		closeGatewayMenu: PropTypes.string,
		changeGateway: PropTypes.string,
		gatewayHeader: PropTypes.string,
	}),
	showGateway: PropTypes.bool,
	onGatewayChange: PropTypes.func,
	focusOnShouldIgnore: PropTypes.func,
};

GatewayMenu.defaultProps = {
	labels: {
		openGatewayMenu: "Open gateway menu",
		closeGatewayMenu: "Close gateway menu",
		changeGateway: "Change gateway",
		gatewayHeader: "Gateway",
	},
	showGateway: true,
	onGatewayChange: () => {},
	focusOnShouldIgnore: () => true,
};

export default GatewayMenu;
export { GatewayMenu };
